__turbopack_context__.v({
  "productPrice": "product-price-module-scss-module__d7E4cq__productPrice",
  "productPriceCentered": "product-price-module-scss-module__d7E4cq__productPriceCentered",
  "productPriceColumn": "product-price-module-scss-module__d7E4cq__productPriceColumn",
  "productPriceFlat": "product-price-module-scss-module__d7E4cq__productPriceFlat",
  "productPriceMain": "product-price-module-scss-module__d7E4cq__productPriceMain",
  "productPriceMainMin": "product-price-module-scss-module__d7E4cq__productPriceMainMin",
  "productPriceOldPrice": "product-price-module-scss-module__d7E4cq__productPriceOldPrice",
  "productPriceOldPriceCentered": "product-price-module-scss-module__d7E4cq__productPriceOldPriceCentered",
  "productPriceOldPriceColumn": "product-price-module-scss-module__d7E4cq__productPriceOldPriceColumn",
  "productPriceOldPriceFlat": "product-price-module-scss-module__d7E4cq__productPriceOldPriceFlat",
  "productPriceOldPriceMargin": "product-price-module-scss-module__d7E4cq__productPriceOldPriceMargin",
  "productPriceOldPriceMin": "product-price-module-scss-module__d7E4cq__productPriceOldPriceMin",
  "productPriceRevert": "product-price-module-scss-module__d7E4cq__productPriceRevert",
});
